import React from "react";
import NumberBoxCSS from "./numberBox.module.scss";

const NumberBox = (props) => {
  return (
    <article className={`${NumberBoxCSS.numberBox} ${props.cssStyle}`}>
      <p> {props.number} </p>
    </article>
  );
};

export default NumberBox;
